<template>
  <div class="app-form-group" :class="groupClasses">
    <label v-if="label" :for="labelFor" class="app-form-group__label">
      {{ label }}
    </label>
    <div class="app-form-group__content">
      <slot />
    </div>
    <small v-if="description || $slots.description" class="app-form-group__description">
      <slot name="description">{{ description }}</slot>
    </small>
    <small v-if="showInvalidFeedback" class="app-form-group__feedback app-form-group__feedback--invalid">
      <slot name="invalid-feedback">{{ invalidFeedback || errorMessage }}</slot>
    </small>
    <small v-if="showValidFeedback" class="app-form-group__feedback app-form-group__feedback--valid">
      <slot name="valid-feedback">{{ validFeedback }}</slot>
    </small>
  </div>
</template>

<script>
export default {
  name: 'AppFormGroup',
  props: {
    label: { type: String, default: '' },
    labelFor: { type: String, default: '' },
    description: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    invalidFeedback: { type: String, default: '' },
    validFeedback: { type: String, default: '' },
    state: { type: Boolean, default: null }
  },
  computed: {
    showInvalidFeedback() {
      // Show if state is explicitly false, or if there is any error/invalid message provided when not explicitly true
      return this.state === false || (this.state !== true && (!!this.errorMessage || !!this.invalidFeedback));
    },
    showValidFeedback() {
      return this.state === true && !!this.validFeedback;
    },
    groupClasses() {
      return {
        'app-form-group--valid': this.state === true,
        'app-form-group--invalid': this.state === false || (this.state !== true && (!!this.errorMessage || !!this.invalidFeedback))
      }
    }
  }
}
</script>

<style scoped>
.app-form-group {
  margin-bottom: 1rem;
  width: 100%;
}

.app-form-group__label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #939393;
}

.app-form-group__content {
  position: relative;
}

.app-form-group__description {
  display: block;
  margin-top: 4px;
  font-size: 80%;
  color: #6c757d;
}

.app-form-group__feedback {
  display: block;
  margin-top: 4px;
  font-size: 80%;
}

.app-form-group__feedback--invalid {
  color: #F46A6A;
}

.app-form-group__feedback--valid {
  color: #34C38F;
}
</style>
